import { BenchObjectSkeleton } from './BenchObjectSkeleton';

type Props = {
  rowsNumber: number;
};

export const BenchObjectSkeletons = ({ rowsNumber }: Props) => {
  return [...Array(rowsNumber).keys()].map(i => (
    <BenchObjectSkeleton key={i} />
  ));
};
